import { useDispatch } from 'react-redux';
import React from 'react';
import { getDocumentsMetaDataAction } from '@data/documentSignedUrl/actionCreators/DocumentSignedUrlActionCreators';
import {
	DocumentsMetaDataPayload,
} from '@data/documentSignedUrl/types/DocumentsMetaDataRequest';

const useGetDocumentsMetaData = () => {
	const dispatch = useDispatch();

	return React.useCallback((requestOverrides: DocumentsMetaDataPayload) => {
		dispatch(getDocumentsMetaDataAction(requestOverrides));
	}, [dispatch]);
};

export default useGetDocumentsMetaData;
